export default {"src":"/_next/static/image/components/ui/Icon/icons/vk.094cf829870a020ebbfed9b5890ffa40.svg","height":11,"width":18};